var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 171,
    viewBox: "0 0 162 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7141 159.201C15.5372 159.201 7.9961 154.502 3.7247 147.117C-1.09103 138.773 -1.09102 128.799 2.90678 120.072L55.8767 28.5783C61.8732 19.2752 69.6872 11.7947 81.0448 11.7947C92.4022 11.7947 100.216 19.2754 106.213 28.5783L158.91 119.593C163.271 128.129 163.09 138.87 158.274 147.118C154.004 154.503 146.553 159.203 138.285 159.203H23.7129L23.7141 159.201ZM81.046 111.441C85.8617 111.441 89.6776 115.565 89.6776 120.648C89.6776 125.731 85.8617 129.759 81.046 129.759C76.2302 129.759 72.3237 125.731 72.3237 120.648C72.3237 115.564 76.2308 111.441 81.046 111.441ZM81.046 102.33C77.866 102.33 75.5943 99.548 75.231 96.1916L72.3237 68.6663C71.8697 63.9671 76.5942 59.5551 81.046 59.5551C85.4979 59.5551 90.2229 63.9671 89.6776 68.6663L86.7704 96.1916C86.4977 99.4524 84.317 102.33 81.046 102.33ZM23.7141 147.022H138.286C142.556 147.022 146.191 144.528 148.462 140.692C151.097 136.089 151.006 130.526 148.916 125.731L96.5821 35.3877C92.8569 29.6331 88.2231 23.9749 81.0449 23.9749C73.8672 23.9749 69.1428 29.6331 65.4173 35.3877L13.1737 125.731C10.9931 130.622 10.9024 136.089 13.6277 140.692C15.8082 144.529 19.4427 147.022 23.7132 147.022H23.7141Z",
    fill: "#D44848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 171,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleError);
export default __webpack_public_path__ + "static/media/triangle_error.bab8dd401a1a5f733ad479827f4e4f53.svg";
export { ForwardRef as ReactComponent };